module.exports = __webpack_public_path__ + "static/waukeen-symbol-SCAG-d2ad50fbb56130d0154db7c875f626ad.png";